import { Link } from "react-router-dom";

export default function Footer({ dark = false }) {
  const base = dark ? "text-zinc-400 border-white/10" : "text-zinc-500 border-zinc-200";
  return (
    <footer className={`border-t ${base} py-8 relative z-10`}>
      <div className="max-w-6xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs">
        <div className="flex items-center gap-5">
          <Link to="/how-it-works" data-testid="footer-how" className="hover:text-[#1F6FE5] transition-colors">How it works</Link>
          <Link to="/guide" data-testid="footer-guide" className="hover:text-[#1F6FE5] transition-colors">Guide</Link>
          <Link to="/pricing" data-testid="footer-pricing" className="hover:text-[#1F6FE5] transition-colors">Pricing</Link>
          <Link to="/security" data-testid="footer-security" className="hover:text-[#1F6FE5] transition-colors">Security</Link>
          <Link to="/terms" data-testid="footer-terms" className="hover:text-[#1F6FE5] transition-colors">Terms of Use</Link>
          <Link to="/privacy" data-testid="footer-privacy" className="hover:text-[#1F6FE5] transition-colors">Privacy Policy</Link>
        </div>
        <div className="font-mono flex flex-wrap items-center gap-x-2 justify-center">
          <span>Powered by</span>
          <span className="font-bold text-[#14B8A6]">I-Assist Pro</span>
          <span>·</span>
          <a href="mailto:info@iassistpro.com" className="hover:text-[#1F6FE5] transition-colors">info@iassistpro.com</a>
        </div>
      </div>
    </footer>
  );
}
